export default "__VITE_ASSET__DwiKW1sJ__"